// extracted by mini-css-extract-plugin
export var currencyInput = "_j8-1";
export var currencySymbol = "_j8-0";